// Minimal cn utility compatible with Tailwind v4
// When clsx and tailwind-merge are available, swap implementation to import them.
export type ClassValue =
  | string
  | number
  | false
  | null
  | undefined
  | Array<ClassValue>
  | { [k: string]: unknown };

function toString(x: ClassValue): string {
  if (!x) return "";
  if (typeof x === "string" || typeof x === "number") return String(x);
  if (Array.isArray(x)) return x.map(toString).filter(Boolean).join(" ");
  if (typeof x === "object") {
    return Object.entries(x)
      .filter(([, v]) => Boolean(v))
      .map(([k]) => k)
      .join(" ");
  }
  return "";
}

// naive tailwind merge: last wins for exact duplicate tokens
function simpleMerge(input: string): string {
  const parts = input.split(/\s+/).filter(Boolean);
  const seen: Record<string, number> = {};
  const out: Array<string> = [];
  for (const token of parts) {
    seen[token] = (seen[token] ?? 0) + 1;
    // keep all; last conflicting tokens will naturally be later in the string
    out.push(token);
  }
  return out.join(" ");
}

export function cn(...inputs: Array<ClassValue>): string {
  const flat = inputs.map(toString).filter(Boolean).join(" ");
  return simpleMerge(flat);
}
